"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "foggia": {
    "a4d3745d": [{
      "hkey": "6d723751",
      "slug": "foggia",
      "name": "Foggia",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-mezzanone": [{
      "hkey": "6d723751",
      "slug": "foggia",
      "name": "Foggia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "892414c5": [{
      "hkey": "6b4eadb7",
      "slug": "quartieri-settecenteschi",
      "name": "Quartieri Settecenteschi",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "4b36fa6d",
      "slug": "repubblica-stazione",
      "name": "Repubblica-Stazione",
      "primary": false,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "6b4eadb7",
      "slug": "quartieri-settecenteschi",
      "name": "Quartieri Settecenteschi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "foggia"
    }],
    "323c5c6e": [{
      "hkey": "4e4af48f",
      "slug": "comparto-biccari-ospedale-nuovo",
      "name": "Comparto Biccari-Ospedale Nuovo",
      "primary": true,
      "skipSearch": false
    }],
    "comparto-biccari": [{
      "hkey": "4e4af48f",
      "slug": "comparto-biccari-ospedale-nuovo",
      "name": "Comparto Biccari-Ospedale Nuovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ff6bae29": [{
      "hkey": "8e3262a5",
      "slug": "ordona-sud-macchia-gialla-tribunale",
      "name": "Ordona Sud-Macchia Gialla-Tribunale",
      "primary": true,
      "skipSearch": false
    }],
    "macchia-gialla": [{
      "hkey": "8e3262a5",
      "slug": "ordona-sud-macchia-gialla-tribunale",
      "name": "Ordona Sud-Macchia Gialla-Tribunale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4ade1538": [{
      "hkey": "ce08383d",
      "slug": "rione-immacolata-san-pio-x",
      "name": "Rione Immacolata-San Pio X",
      "primary": true,
      "skipSearch": false
    }],
    "padre-pio-michelangelo": [{
      "hkey": "ce08383d",
      "slug": "rione-immacolata-san-pio-x",
      "name": "Rione Immacolata-San Pio X",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "64230b85": [{
      "hkey": "fc1acaa2",
      "slug": "rione-candelaro",
      "name": "Rione Candelaro",
      "primary": true,
      "skipSearch": false
    }],
    "periferia-popolari": [{
      "hkey": "fc1acaa2",
      "slug": "rione-candelaro",
      "name": "Rione Candelaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "foggia"
    }],
    "66ab1221": [{
      "hkey": "c2016072",
      "slug": "aldo-moro-parco-san-felice-san-michele",
      "name": "Aldo Moro-Parco San Felice-San Michele",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele-moro": [{
      "hkey": "c2016072",
      "slug": "aldo-moro-parco-san-felice-san-michele",
      "name": "Aldo Moro-Parco San Felice-San Michele",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "foggia"
    }],
    "4c7fac60": [{
      "hkey": "c2016072",
      "slug": "aldo-moro-parco-san-felice-san-michele",
      "name": "Aldo Moro-Parco San Felice-San Michele",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "c2016072",
      "slug": "aldo-moro-parco-san-felice-san-michele",
      "name": "Aldo Moro-Parco San Felice-San Michele",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;